module.exports = __webpack_public_path__ + "fonts/ionicons.143146fa.woff2";